import React, { useRef } from 'react';

import CreateMeetingMobileButton from '../CreateMeetingMobileButton';
import DropdownMenu from '../DropdownMenu';

import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import classes from './styles.module.scss';
import videoIcon from '../../assets/images/create-meeting/video.svg';
import fileIcon from '../../assets/images/create-meeting/file.svg';

export default function UploadMenu({
  createDefaultSectionName,
  setSectionTitle,
  setIsUpdateMeetingTitleModalVisible,
  onFileSelect, // Optional callback for Redux-based flow (new editor)
  onRequestWakeLock, // Optional callback to request wake lock on user gesture
}) {
  const captureFileInputRef = useRef();
  const pickerFileInputRef = useRef();

  const isMobile = useCheckMobileScreen();

  const startCaptureVideo = () => {
    if (!isMobile) {
      return;
    }

    const title = createDefaultSectionName({
      placeholderType: 'video',
    });

    setSectionTitle(title);

    if (onRequestWakeLock) {
      onRequestWakeLock();
    }

    captureFileInputRef.current?.click();
  };

  const startPicker = (accept, fileTypeHint) => {
    if (!isMobile) {
      return;
    }

    const title = createDefaultSectionName({
      placeholderType: fileTypeHint,
    });

    setSectionTitle(title);

    if (onRequestWakeLock) {
      onRequestWakeLock();
    }

    if (!pickerFileInputRef.current) {
      return;
    }

    pickerFileInputRef.current.accept = accept;
    pickerFileInputRef.current.click();
  };

  const detectFileType = (file) => {
    const mimeType = file?.type || '';
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType.startsWith('video/')) return 'video';

    const name = (file?.name || '').toLowerCase();
    if (/\.(png|jpe?g|heic|heif|gif|webp|bmp|tiff?)$/.test(name)) return 'image';

    return 'video';
  };

  const videoAccept =
    'video/mp4, video/quicktime, video/x-ms-wmv, video/x-msvideo, video/webm';
  const pickerAccept = `image/*, ${videoAccept}`;

  const options = [
    {
      label: 'Take Video',
      onClick: () => {
        startCaptureVideo();
      },
      icon: <img src={videoIcon} alt="Take Video" />,
      disabled: false,
    },
    {
      label: 'Choose Video or Image',
      onClick: () => {
        startPicker(pickerAccept, 'video');
      },
      icon: <img src={fileIcon} alt="Choose File" />,
      disabled: false,
    },
  ];

  // Handle file selection - use callback if provided
  const handleFileSelect = async (file, fileType) => {
    // eslint-disable-next-line no-console
    console.log('[UploadMenu] handleFileSelect', {
      name: file?.name,
      size: file?.size,
      type: file?.type,
      fileType,
    });
    if (onRequestWakeLock) {
      onRequestWakeLock();
    }
    let accepted = true;
    if (onFileSelect) {
      // eslint-disable-next-line no-console
      console.log('[UploadMenu] calling onFileSelect');
      const result = onFileSelect(file, fileType);
      accepted = result instanceof Promise ? await result : result;
    }
    // eslint-disable-next-line no-console
    console.log('[UploadMenu] selection accepted?', accepted);
    if (accepted === false) {
      return;
    }
    // Always show title modal
    setIsUpdateMeetingTitleModalVisible(true);
  };

  const videoInputAttributes = {
    type: 'file',
    style: { display: 'none' },
    onChange: async (event) => {
      const { target } = event;
      const file = target.files[0];
      if (file) {
        const fileType = detectFileType(file);
        // eslint-disable-next-line no-console
        console.log('[UploadMenu] input onChange', {
          name: file?.name,
          size: file?.size,
          type: file?.type,
          fileType,
        });
        setSectionTitle(
          createDefaultSectionName({
            placeholderType: fileType,
          })
        );
        await handleFileSelect(file, fileType);
      }
      // Reset input so same file can be selected again
      target.value = '';
    },
    accept: videoAccept,
  };

  return (
    <div className={classes.UploadMenu}>
      <DropdownMenu
        options={options}
        menuStyle={{ right: '50%', bottom: -78, transform: 'translateX(50%)' }}
      >
        <div className={classes.outerButtonContainer}>
          <div className={classes.innerButtonContainer}>
            <CreateMeetingMobileButton
              style={{ position: 'static', zIndex: 0 }}
              onClick={() => {}}
            />
          </div>
        </div>
      </DropdownMenu>
      <span>Upload from my device</span>
      <input {...videoInputAttributes} ref={captureFileInputRef} capture="user" />
      <input {...videoInputAttributes} ref={pickerFileInputRef} />
    </div>
  );
}
